export const GET_CURRENT_SUBSCRIPTIONS = "error:knowledgeBase:get-current-subscriptions"
export const UPDATE_SUBSCRIPTIONS = "error:knowledgeBase:update-subscriptions"
